import type { PortfolioLifecycleRow } from '../../productgovernance/framework';

type Props = { items?: PortfolioLifecycleRow[] };

export function PortfolioLifecyclePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-400">{item.category}</p>
              <p className="text-sm font-medium">{item.item}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold text-brand-600">{item.count}</p>
              <p className="text-xs text-slate-500">{item.status}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
